import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { HOME_DATA } from "../../Public/constants";
import { getUser } from "../../redux/Action";
import { useDispatch } from "react-redux";

const Homecard = ({ title, description, icon }) => {
  return (
    <>
      <div className="text-center shadow-md px-6 py-6 rounded-lg bg-gray-100 border dark:border-none dark:bg-[#1d1e2b]">
        <span className="inline-block text-4xl">{icon()}</span>
        <h2>{title}</h2>
        <p className="text-sm">{description}</p>
      </div>
    </>
  );
};

const Home = () => {
  const location = useLocation();
  const query = location?.search?.substring(1);
  const dispatch = useDispatch();

  if (query.length > 1) {
    localStorage.setItem("jwtoken", query);
  }

  useEffect(() => {
    document.title = "Blogshog | Home";
    if (query.length > 1) {
      getUser(dispatch);
    }
  }, [query]);

  return (
    <main className="text-black dark:text-white py-10">
      <section className="sm:w-[60%] w-full sm:px-0 py-12 m-auto text-center">
        <h1 className="sm:text-[4rem] text-3xl pt-6 py-2 font-extrabold leading-none dark:text-gray-100">
          Welcome to Blogshog! Your Platform for Creative Expression
        </h1>
        <p className="sm:w-[80%] sm:text-base py-2 text-sm m-auto">
          Are you passionate about sharing your thoughts, experiences, and
          expertise with the world? Look no further! Blogshog is your ultimate
          destination for creating and publishing your own blogs with ease.
        </p>
        <Link
          to="/blogs/create"
          className="inline-flex mt-6 text-white bg-[#1D4ED8] border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-md"
        >
          Create Your First Blog
        </Link>
      </section>

      <section className="w-[80%] m-auto mt-[5rem] grid sm:grid-cols-3 gap-[2rem]">
        {HOME_DATA.map((data, i) => (
          <Homecard key={i} {...data} />
        ))}
      </section>
    </main>
  );
};

export default Home;
